// ترتيب الشاشة في تطبيق الوالدين، بالعربية (انظر boardConfigApp.nl.ts).
export const appBoardConfigAr = {
    open: 'ترتيب الشاشة',
    title: 'ترتيب الشاشة',
    intro: 'حرّك الأدوات في الشبكة واجعلها أضيق أو أعرض أو أقصر أو أطول: كلما كبرت أظهرت أكثر. للوحة حتى 12 صفحة؛ على اللوحة اسحب جانبًا إلى الصفحة التالية.',
    standard: 'تعرض هذه اللوحة الآن الترتيب الافتراضي. غيّر شيئًا لتصنع ترتيبك.',
    onBoard: 'على اللوحة',
    available: 'إضافة',
    nothingToAdd: 'كل أدوات وحداتكم موجودة بالفعل.',
    empty: 'لا شيء في هذه الصفحة بعد. أضف شيئًا أدناه.',
    size: 'الحجم',
    style: 'الشكل',
    moveUp: 'نقل {name} لأعلى',
    moveDown: 'نقل {name} لأسفل',
    remove: 'إزالة {name}',
    pageEarlier: 'تقديم {name}',
    pageLater: 'تأخير {name}',
    pageRemove: 'إزالة {name}',
    onPage: 'في {name}',
    weekSketch: 'جدول الأسبوع',
    phoneHint: 'النقل وتغيير الحجم على جهاز لوحي أو حاسوب. هنا تختار ما يظهر في كل صفحة.',
    add: 'إضافة {name}',
    reset: 'الترتيب الافتراضي',
    save: 'حفظ',
    saved: 'تم الحفظ. تتكيف اللوحة خلال دقيقة.',
    resetDone: 'الترتيب الافتراضي جاهز. احفظ لوضعه على اللوحة.',
    failed: 'لم ينجح الحفظ. حاول بعد قليل.',
    conflict: 'تغيّرت هذه اللوحة في الأثناء، ربما على اللوحة نفسها. يظهر الآن أحدث ترتيب.',
    preview: 'معاينة',
    previewNote: 'ببيانات تجريبية؛ اللوحة تستخدم بياناتكم.',
    screen: 'الشاشة',
    screens: { large: 'iPad', wide: 'جهاز لوحي عريض', compact: 'جهاز لوحي صغير' },
    gestureTitle: 'الضبط على اللوحة نفسها',
    gestureBody: 'المس ساعة اللوحة ثلاث مرات بسرعة وأدخل رمز الوالدين. تُغلق تلقائيًا بعد دقيقة دون لمس.',
    pinTitle: 'رمز الوالد الشخصي',
    pinBody: 'استخدم رمزك الخاص. لكل والد رمز شخصي.',
    pinLabel: 'رمز والدين جديد',
    pinSave: 'حفظ الرمز',
    pinSaved: 'تم حفظ رمز الوالدين.',
    pinInvalid: 'اختر من 4 إلى 6 أرقام.',
    pinTaken: 'يستخدم والد آخر هذا الرمز بالفعل. اختر رمزًا آخر.',
    back: 'العودة إلى الأجهزة اللوحية',
    names: {
        prayer: 'مواقيت الصلاة',
        weather: 'الطقس',
        tasks: 'المهام',
        rides: 'التوصيل والاصطحاب',
        meals: 'الطعام',
        upcoming: 'قريبًا',
        messages: 'الرسائل',
        memorize: 'حفظ السور',
        dinner: 'من سيأكل معنا',
        bookings: 'الحجوزات',
        precip: 'الهطول',
        week: 'الأسبوع (الصغرى والكبرى)',
        quran: 'الاستماع إلى القرآن',
        todos: 'المهام اللاحقة',
        notes: 'الملاحظات',
        // 0068: Gezond op gewicht.
        kompas: 'عادات صحية (وزن صحي)',
        // 0076: schoolplanner (nooit een cijfer op het bord).
        school: 'المدرسة (الواجبات والاختبارات)',
        // 0062: module Jodendom.
        shabbat: 'السبت والتقويم',
        // 0061: Kerk & kalender.
        seasons: 'الكنيسة والتقويم',
        // 0063: module Hindoeïsme.
        almanac: 'البانشانغ والأعياد',
        // UX-ronde bord: Boodschappen (module Eten) en Beloningen.
        groceries: 'قائمة التسوق',
        rewards: 'المكافآت',
        // 0075: Huisronde (module Eten).
        house_round: 'جولة المنزل',
        // Widgets compleet: Wensen, Foto (Fotolijst), Timer, Schoonmaak en Beurtrooster.
        wishes: 'الأمنيات',
        photo: 'صورة (إطار الصور)',
        timer: 'المؤقّت',
        cleaning: 'التنظيف',
        rotation: 'جدول الأدوار',
        // Widgets privé (0077): de gewone nieuwe widgets en de privé-widgets.
        clock: 'الساعة',
        travel: 'الخروج',
        stock: 'المخزون',
        cookbook: 'دفتر الطبخ',
        reminders: 'التذكيرات',
        checkin: 'الاطمئنان اليومي',
        fasting: 'الصيام',
        growth: 'النمو',
        money: 'الشؤون المالية',
        expenses: 'تقاسم التكاليف',
        my_todos: 'مهام خاصة',
        circle: 'دائرة العائلة',
    },
    sizes: { S: 'صغير', M: 'متوسط', L: 'كبير', XL: 'كبير جدًا' },
    sizeHints: {
        S: 'الأهم بنظرة واحدة',
        M: 'اليوم',
        L: 'اليوم والغد بتفاصيل أكثر',
        XL: 'كل شيء، على شاشة عريضة',
    },
    /** Fijnslijpen ouderapp: Brengen en halen, de ophaaltijd als schakelaar (stijl list of no_pickup). */
    ridesPickup: 'إظهار وقت الاصطحاب',
    ridesPickupHint: 'مثلًا "بابا يصطحب 16:50". عند الإيقاف: من يصطحب فقط.',
    styles: {
        // Widget Foto.
        slideshow: 'تتغيّر كل دقيقة',
        daily: 'صورة اليوم',
        no_pickup: 'بدون وقت الاصطحاب',
        list: 'قائمة',
        ring: 'ساعة',
        compact: 'مختصر',
        illustrated: 'مع صورة',
        today: 'اليوم فقط',
        bars: 'أعمدة',
    },
    /** Koran luisteren: "Over de opnames" bij de widget. */
    quran: {
        aboutTitle: 'عن التسجيلات',
        aboutBody: 'تلاوة {name}. المصدر: {source}.',
        familyOnly: 'لا يوجد ترخيص معروف: هذه التسجيلات لعائلتكم فقط.',
        none: 'لا توجد تسجيلات لعائلتكم بعد.',
    },
    /** Voorbeeldgezin in het voorbeeld van "Scherm inrichten" (kiosk-ui widgets/sample.ts). */
    samples: {
        // Widgets compleet: wensen, klussen en een bijschrift van het voorbeeldgezin.
        wishLego: 'سفينة فضاء ليغو',
        wishBook: 'كتاب الحيوانات',
        wishSkates: 'حذاء تزلج',
        choreBathroom: 'الحمّام',
        choreVacuum: 'الكنس بالمكنسة',
        choreBins: 'إخراج القمامة',
        photoCaption: 'صيف على البحر',
        school: 'المدرسة',
        swimming: 'درس السباحة',
        judo: 'جودو',
        brushTeeth: 'تنظيف الأسنان',
        packBag: 'تجهيز الحقيبة',
        makeBed: 'ترتيب السرير',
        setTable: 'تجهيز المائدة',
        groceries: 'التسوق',
        birthday: 'نور تبلغ 8 سنوات',
        autumnBreak: 'عطلة الخريف',
        pasta: 'معكرونة بالبيستو',
        soup: 'شوربة',
        curry: 'كاري',
        pancakes: 'فطائر',
        pizza: 'بيتزا',
        stew: 'يخنة',
        inHours: '{n} س',
        paintCupboard: 'طلاء خزانة الأحذية',
        fixBike: 'إصلاح إطار الدراجة',
        clearGutter: 'تنظيف المزراب',
        noteMilk: 'نفد الحليب',
        noteSwim: 'لا تنسَ حقيبة السباحة',
        // UX-ronde bord: voorbeeld voor de widgets Boodschappen en Beloningen.
        milk: 'حليب',
        bread: 'خبز',
        apples: 'تفاح',
        cheese: 'جبن',
        cinema: 'السينما',
    },
};
//# sourceMappingURL=boardConfigApp.ar.js.map